// Libs
import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
// App
import mainTeme from '../../theme/theme';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export class SnackbarService {
  /**
   * Gets the container of the snackbar
   * @returns the container dom element
   */
  private static getContainer() {
    return document.querySelector('#snackbar');
  }

  /**
   * Creates a container for snackbar
   */
  private static createContainer() {
    const container = document.createElement('div');

    container.setAttribute('id', 'snackbar');
    document.body.appendChild(container);

    return this.getContainer();
  }

  /**
   * Destroys the container of snackbar
   * @param element the html element of the container
   */
  public static cleanup() {
    const container = this.getContainer();

    if (container !== null) {
      ReactDOM.unmountComponentAtNode(container);
    }
  }

  /**
   * Manages component creation and destruction
   * @param content the snackbar (dialogProps)
   */
  private static createSnackbar(snackbar: (onClose: () => void) => ReactElement): void {
    const container = this.createContainer();
    const onClose = () => {
      this.cleanup();
    };

    ReactDOM.render(
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={mainTeme}>{snackbar(onClose)}</ThemeProvider>
      </StyledEngineProvider>,
      container
    );
  }

  /**
   * Displays a snackbar
   * @param snackbar the snackbar to display
   */
  public static showSnackbar(snackbar: (onClose: () => void) => ReactElement) {
    if (this.getContainer()) {
      this.cleanup();
    }

    return this.createSnackbar(snackbar);
  }
}
